export default __webpack_public_path__ + "static/media/img-guide-gt-popup-2-se_se.1d10a8c7.png";